<script lang="ts">
import { createEventDispatcher } from 'svelte';
import type { CourseListItem, LectureListItem } from '../api/types';
import { formatDate } from '../email/format';
import courses from '../store/courses';
import { timePart } from './Input.svelte';

export let course: CourseListItem;
export let selected: string;
let lectures: LectureListItem[];

$: lectures = course ? course.lectures.map(ref => $courses.lectures[ref.id]).filter(Boolean) : [];

const dispatch = createEventDispatcher();

function datePart(value: string) {
    return value ? formatDate(new Date(value), '%D.%M') : '';
}

</script>
<style lang="scss">
ul {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    padding: 0;
    margin: 16px 0;
    justify-content: flex-start;
}

li {
    flex: 0 0 100px;
    margin: 0 16px 16px 0;

    a {
        display: block;
        background: #ecf4f8;
        color: inherit;
    }
}

.item {
    width: 100px;
    height: 100px;
    padding: 8px;
    border-radius: 5px;
}

.num {
    text-align: center;
    font-weight: 900;
    font-size: 20px;
    line-height: 20px;
    color: #F375B9;
}

.title {
    $lines: 3;
    $line-height: 14px;

    text-align: center;
    line-height: $line-height;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    margin-top: 8px;
    color: #333;
    height: $line-height * $lines;
    display: -webkit-box;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}

.date {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
}

.selected {
    a {
        background: #d1dde4;
    }
}

.add {
    background: #fcdced;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
</style>

<ul>
    {#each lectures as lecture, i (lecture.id)}
        <li class:selected={lecture.id === selected}>
            <a class="item" href="#{course.id}/{lecture.id}">
                <div class="num">{i + 1}</div>
                <div class="title">{lecture.title || lecture.timepadEventId || lecture.id}</div>
                <div class="date">
                    <span>{datePart(lecture.dateStart)}</span>
                    <span>{timePart(lecture.dateStart)}</span>
                </div>
            </a>
        </li>
    {/each}
    <li class="add item" on:click={() => dispatch('add')}>
        <div class="title">+ Добавить новую лекцию</div>
    </li>
</ul>
